function openWindow(url, name, props) {
  let windowRef = null;
  windowRef = window.open(url, name, props);
  if (!windowRef.opener) {
    windowRef.opener = self;
  }
  windowRef.focus();
  return windowRef;
}

export const VueHtmlToPaper = {
  print: (el, localOptions?, cb = () => true) => {
    const defaultName = '_blank',
      defaultSpecs = ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
      defaultReplace = true,
      defaultStyles = [],
      defaultWindowTitle = window.document.title;
    let {
      name = defaultName,
      specs = defaultSpecs,
      replace = defaultReplace,
      styles = defaultStyles,
      autoClose = true,
      windowTitle = defaultWindowTitle,
    }: any = localOptions;

    // If has localOptions
    // TODO: improve logic
    if (localOptions) {
      if (localOptions.name) name = localOptions.name;
      if (localOptions.specs) specs = localOptions.specs;
      if (localOptions.replace) replace = localOptions.replace;
      if (localOptions.styles) styles = localOptions.styles;
      if (localOptions.autoClose === false) autoClose = localOptions.autoClose;
      if (localOptions.windowTitle) windowTitle = localOptions.windowTitle;
    }

    specs = specs.length ? specs.join(',') : '';

    const element = window.document.getElementById(el);

    if (!element) {
      alert(`Element to print #${el} not found!`);
      return;
    }

    const url = 'https://goover.ai/';
    const win = openWindow(url, name, specs);

    win.document.write(`
        <html>
          <head>
            <style type="text/css">
              @media print {
                body {-webkit-print-color-adjust: exact;}
              }
              h1,h2,h3, h4, ul, ol, p {
                padding: 0;
                margin: 0;
              }
                h5 {
                color: #888888;
                font-size: 16px;
              }
             .go-detail-content {
                position: relative;
                width: 100%;
                color: #404040 !important;
                font-family: NanumGothic, Roboto, -apple-system, BlinkMacSystemFont, "맑은 고딕", helvetica, "Apple SD Gothic Neo", sans-serif;
                font-size: 0.875rem;
                line-height: 1.4;
                padding-bottom: 1rem;
                /*background-color: #fff !important;*/
              }
             .go-detail-report{
                position: relative;
                overflow: hidden;
                width: 100%;
                font-family: NanumGothic, Roboto, -apple-system, BlinkMacSystemFont, "맑은 고딕", helvetica, "Apple SD Gothic Neo", sans-serif;
                font-size: 0.875rem;
                text-align: justify;
                border-radius: 0.5rem;
               }
            .go-detail-content :before {
                z-index: 1;
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                display: inline-block;
                width: 100%;
                height: 106px;
              }

             /*:after {*/
             /*   content: '';*/
             /*   position: absolute;*/
             /*   bottom: 0;*/
             /*   left: 0;*/
             /*   right: 0;*/
             /*   display: inline-block;*/
             /*   width: 100%;*/
             /*   height: 24px;*/
             /*   !*background-color: #fafafa !important;*!*/
             /* }*/

              .go-report-cover {
                z-index: 1;
                position: relative;
                padding: 1px 0;
              }

              .go-report-cover:after {
                z-index: -1;
                content: '';
                display: inline-block;
                position: absolute;
                left: 0;
                bottom: 0;
                width: 60%;
                height: 50%;
                /*background-color: #f18c3c !important;*/
              }

              .go-report-cover .go-cover-image {
                display: block;
                overflow: hidden;
                width: 464px;
                height: 464px;
                font-size: 0;
                box-sizing: border-box;
                margin: 0 auto;
                border: 10px solid #fafafa;
              }

              .go-report-section table {
                white-space: nowrap;
                margin-left: 1rem;
                width: calc(100% - 1rem) !important;
              }
              .go-report-section table th {
                width:100%  !important;
              }


              .go-report-cover .go-block-body {
               height: 60rem;
               padding: 2rem;
               background-color: #121212 !important;
              }

              .go-report-cover .go-cover-image img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

             .go-block-body .go-block-text {
                 display: flex;
                 flex-direction: column;
                 align-items: center;
              }

              /*.go-report-cover-style-01 .go-block-footer {*/
              /*    padding: -10rem 1rem;*/
              /*}*/
              /*.go-report-cover .go-report-type {*/
              /*  padding: -1rem 0 0 0 ;*/
              /*  display: flex;*/
              /*  justify-content: center;*/
              /*  align-items: center;*/
              /*  width: 444px;*/
              /*  !*margin: 2rem auto;*!*/
              /*  text-align: center;*/
              /*}*/

              .go-detail-report .go-report-cover h1 {
                display: block;
                color: #222222;
                font-size: 2rem;
                font-weight: 700;
                line-height: 1.5;
                letter-spacing: -0.25px;
                text-align: center;
              }

             .go-report-cover .go-report-title {
                color: #fff !important;
                margin: 1.5rem 1rem 1rem;
              }

              .go-report-type {
                color: #888888;
                font-size: 1rem;
                font-weight: bold;
              }

              .go-report-datetime {
              position: relative;
              color: #888888;
              font-size: 1rem;
              font-weight: bold;
              letter-spacing: -0.25px;
              padding-left: 1rem;
              margin-left: 0.5rem;
              }

              .go-help-text {
                display: none;
              }

              .go-report-cover-style-01 .go-block-body .go-block-text {
                padding-top: 2rem;
              }

              .go-detail-report .go-report-category {
                display: inline-block;
                padding: 0.5rem 1rem;
                line-height: 1;
                font-size: 0.875rem;
                background-color: #fd7e14;
                color: #fff;
                border-radius: 6.25rem;
              }

              .no-class {
              display: flex;
              align-items: center;
              justify-content: center;
              }

              /*.go-report-toc {*/
              /*  padding: 3rem 3rem 5rem;*/
              /*}*/

              .go-report-toc ol li {
                margin-top: 0.5rem;
              }

              .go-report-contents h2 {
                font-size: 1.25rem;
                margin-bottom: 1.5rem;
              }

              .go-report-contents h3 {
                font-size: 1rem;
                margin-bottom: 0.25rem;
              }

              .go-report-contents p {
                text-align: justify;
              }

              .go-report-contents p,
              .go-report-contents li {
                margin-bottom: 1rem;
              }

              .go-report-contents .go-report-section {
                padding: 1rem 3rem;
              }

              .go-report-contents .go-report-section.introduction,
              .go-report-contents .go-report-section.conclusion {
                /*color: #fff !important;*/
                /*background-color: #f18c3c !important;*/
              }

              .go-report-source {
                font-size: 0.75rem;
              }

              .go-report-source .source-title {
                margin: 0;
              }

              .go-report-source .source-link {
                display: inline-block;
                color: #888 !important;
                font-size: 85%;
                margin-top: 0.5rem;
              }

              .go-report-table {
                width: 100%;
                border: 1px solid #e4e4e4;
                border-collapse: collapse;
                margin-bottom: 1rem;
              }

              .go-report-table th,
              .go-report-table td {
                font-size: 0.75rem;
                padding: 0.25rem 0.5rem;
                border: 1px solid #e4e4e4;
                vertical-align: middle;
              }

              .go-report-table th {
                color: #404040 !important;
                text-align: center;
                background-color: #f8f8f8 !important;
              }

              .go-report-table td {
                color: #545454 !important;
              }

              .go-report-list-decimal {
                list-style-type: none;
              }

              .go-report-list-decimal li {
                padding-left: 1rem;
              }

              .go-report-list-disc {
                padding-left: 1rem;
                list-style-type: none;
              }

              .go-report-list-disc li {
                position: relative;
              }

              .go-report-list-disc li:after {
                content: '';
                position: absolute;
                top: 0.5rem;
                left: -15px;
                display: inline-block;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #888 !important;
              }
              .go-report-reference-title {
                display: block;
                font-size: 0.75rem;
                margin: 0;
              }
              .go-report-reference-link {
                display: inline-block;
                color: #888;
                font-size: 85%;
                margin-top: 0.25rem;
                text-decoration: none;
              }
             .go-report-cover-style-01 .go-block-body .go-report-madeby {
              display: inline-block !important;
              /*transform: translateX(250px);*/
              overflow: hidden;
              width: 110px;
              margin-top: 3rem;
              }

            /* go-card-gird */
            .go-card-gird {
              display: -ms-grid;
              display: grid;
              grid-gap: 1rem;
              grid-template-columns: repeat(2, 1fr);
              grid-auto-flow: row dense;
              margin: 0 0 1.25rem;
            }

            .go-card-gird .go-gird-item {
              padding: 1.25rem;
              margin: -1px 0 0 -1px;
              border: 1px solid #eeeeee;
              border-radius: 0.5rem;
              background-color: #ffff;
            }

            .go-card-gird .go-gird-item strong {
              position: relative;
              display: inline-block;
              color: black;
              font-size: 1rem;
              font-weight: 600;
              padding-bottom: 1rem;
              margin-bottom: 0.75rem;
            }

            .go-card-gird .go-gird-item strong:after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              display: inline-block;
              width: 32px;
              height: 3px;
              background-color: #fd7e14;
            }

            .go-card-gird .go-gird-item p {
              font-size: 0.875rem;
            }

            .go-card-gird .go-gird-item:nth-child(3n + 1) {
              background-color: #ebfbee;
            }

            /* go-blockquote */
            .go-blockquote {
              position: relative;
              display: block;
              margin: 2rem;
            }

            .go-blockquote .go-blockquote-body {
              position: relative;
            }

            .go-blockquote .go-blockquote-body p {
              font-size: 1rem;
            }

            .go-blockquote .go-blockquote-footer {
              display: flex;
              width: 100%;
              align-items: center;
              font-size: 0.75rem;
              vertical-align: middle;
            }

            .go-blockquote .go-blockquote-footer .go-speaker {
              color: #222222 ;
              font-size: 1.063rem;
              font-weight: 600;
            }

            .go-blockquote .go-blockquote-footer .go-speaker small {
              color: #ababab;
              font-size: 0.75em;
              font-weight: 400;
            }

            .go-blockquote.style1 {
              padding: 1rem;
              border-radius: 1.5rem 1.5rem 0 1.5rem;
              border: 2px solid #eeeeee;
              background-color: #ffffff;
            }

            .go-blockquote.style1 .go-blockquote-body {
              padding: 1.5rem 0.75rem 1rem 1.5rem;
            }

            .go-blockquote.style1 .go-blockquote-body:after {
              content: '';
              position: absolute;
              top: -2.25rem;
              left: -0.5rem;
              width: 164px;
              height: 164px;
              background-image: url("data:image/svg+xml,%3Csvg fill='%2328a745' width='4rem' height='4rem' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.78,8.89c0-3.07,1.53-4.3,4.3-4.34L5.38,6C3.78,6.17,3,7,3.1,8.31H4.54V12H.78Zm5.9,0c0-3.07,1.53-4.3,4.3-4.34L11.28,6C9.68,6.17,8.89,7,9,8.31h1.44V12H6.68Z' /%3E%3C/svg%3E");
              background-size: 100%;
              opacity: 0.24;
            }

            .go-blockquote.style1 .go-blockquote-footer {
              justify-content: flex-end;
              padding: 0 0.75rem 0 1.5rem;
            }

            .go-blockquote.style1 .go-blockquote-footer .go-speaker {
              color:#ebfbee;
            }

            .go-blockquote.style1 .go-blockquote-footer .go-speaker small {
              margin-right: 0.25rem;
            }

            .go-blockquote.style2 {
              padding: 0.5rem 1.75rem;
              text-align: left;
            }

            .go-blockquote.style2:after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              display: inline-block;
              width: 6px;
              height: 100%;
              border-radius: 4px;
              background-color: #eeeeee;
            }

            .go-blockquote.style2 .go-blockquote-footer {
              flex-direction: column;
              align-items: flex-start;
              margin-top: 1rem;
            }

            .go-blockquote.style2 .go-blockquote-footer .go-speaker small {
              display: block;
            }

            .go-blockquote.style3 {
              min-height: 100px;
              padding: 1rem 1.25rem 1.25rem;
              border-radius: 1rem;
              background-color: #ffff;
            }

            .go-blockquote.style3 .go-blockquote-body {
              text-align: center;
              padding: 0.75rem 2.5rem;
            }

            .go-blockquote.style3 .go-blockquote-body:before,
            .go-blockquote.style3 .go-blockquote-body:after {
              content: '';
              position: absolute;
              width: 64px;
              height: 64px;
            }

            .go-blockquote.style3 .go-blockquote-body:before {
              top: -0.5rem;
              left: 0;
              background-image: url("data:image/svg+xml,%3Csvg fill='%23fd7e14' width='4rem' height='4rem' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.78,8.89c0-3.07,1.53-4.3,4.3-4.34L5.38,6C3.78,6.17,3,7,3.1,8.31H4.54V12H.78Zm5.9,0c0-3.07,1.53-4.3,4.3-4.34L11.28,6C9.68,6.17,8.89,7,9,8.31h1.44V12H6.68Z' /%3E%3C/svg%3E");
            }

            .go-blockquote.style3 .go-blockquote-body:after {
              bottom: -0.5rem;
              right: 0;
              background-image: url("data:image/svg+xml,%3Csvg fill='%23fd7e14' width='4rem' height='4rem' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.94,15.11c0,3.07-1.53,4.3-4.3,4.34L12.35,18c1.6-.16,2.39-1,2.28-2.3H13.18V12h3.76Zm5.9,0c0,3.07-1.53,4.3-4.3,4.34L18.24,18c1.6-.16,2.39-1,2.28-2.3H19.08V12h3.76Z' /%3E%3C/svg%3E");
            }

            .go-blockquote.style3 .go-blockquote-footer {
              justify-content: center;
              margin-top: 0.5rem;
            }

            .go-blockquote.style3 .go-blockquote-footer .go-speaker small {
              margin-right: 0.25rem;
            }

            .go-report-contents .go-report-section-info {
              display: none !important;
            }

            .go-detail-comments {
              display: none !important;
            }

            /* summary */
            .go-detail-summary .go-detail-header {
              padding-bottom: 1.25rem;
              border-bottom: 1px solid #eeeeee;
            }

            .go-detail .go-detail-header .go-detail-label-summary {
              color: #fff;
              background-color: #6e8fff;
            }

            .go-detail .go-detail-header .go-detail-label {
              font-size: 0.875rem;
              padding: 0.25rem 0.75rem;
              border-radius: 1rem;
            }

            .go-detail-summary .go-detail-header .go-block-top {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-orient: horizontal;
              -webkit-box-direction: normal;
              -ms-flex-direction: row;
              flex-direction: row;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              justify-content: center;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              -ms-flex-wrap: nowrap;
              flex-wrap: nowrap;
              margin-bottom: 0.5rem;
          }

          .go-detail-summary .go-detail-header .go-detail-title {
            display: block;
            color: #222222;
            font-size: 2rem;
            font-weight: 700;
            line-height: 1.5;
            letter-spacing: -0.25px;
            text-align: center;
          }

          .go-detail-summary .go-detail-header .go-block-bottom {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-box-pack: space-between;
            -ms-flex-pack: space-between;
            justify-content: space-between;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            margin-top: 1.25rem;
          }

          .go-card-info, .go-info-inline {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-box-pack: start;
            -ms-flex-pack: flex-start;
            justify-content: flex-start;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
            color: #888888;
          }

          .go-card-info .go-channel, .go-info-inline .go-channel {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-box-pack: start;
            -ms-flex-pack: flex-start;
            justify-content: flex-start;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
          }

          .go-card-info .go-info-item, .go-info-inline .go-info-item {
            position: relative;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            gap: 0.375rem;
            font-size: 0.8125rem;
            white-space: nowrap;
          }

          .go-card-info .go-channel .go-channel-img, .go-card-info .go-channel .go-channel-thumb, .go-info-inline .go-channel .go-channel-img, .go-info-inline .go-channel .go-channel-thumb {
            position: relative;
            display: block;
            overflow: hidden;
            background-color: #eeeeee;
            width: 16px;
            height: 16px;
            font-size: 0;
            border-radius: 50%;
          }

          .go-card-info .go-channel .go-channel-text, .go-card-info .go-channel .go-channel-name, .go-info-inline .go-channel .go-channel-text, .go-info-inline .go-channel .go-channel-name {
            color: var(--go-color-text-1);
          }

          .go-card-info .go-info-item + .go-info-item, .go-info-inline .go-info-item + .go-info-item {
            padding-left: 0.5rem;
            margin-left: 0.5rem;
          }

          .go-card-info .go-info-item, .go-info-inline .go-info-item {
            position: relative;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            gap: 0.375rem;
            font-size: 0.8125rem;
            white-space: nowrap;
          }

          .go-card-info .go-info-item + .go-info-item:after, .go-info-inline .go-info-item + .go-info-item:after {
            content: "";
            position: absolute;
            left: -1px;
            top: 50%;
            display: inline-block;
            width: 2px;
            height: 2px;
            border-radius: 50%;
            background-color: #888888;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
          }

          .go-icon-view {
            background: none !important;
            display: inline-block;
            width: 24px;
            height: 24px;
          }

          .go-icon-18 {
            display: inline-block;
            vertical-align: middle;
            height: 18px;
            width: 18px;
          }

          .go-card-info .go-info-item em, .go-info-inline .go-info-item em {
            font-style: normal;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
          }

          .go-detail-summary .go-detail-body .go-section-main {
            padding: 2rem 0;
          }

          .go-detail-summary .go-detail-body .go-section-main .go-img-area {
            display: block;
            overflow: hidden;
            width: 100%;
            margin-top: -0.75rem;
            margin-bottom: 2rem;
            border-radius: 0.5rem;
          }

          .go-detail-summary .go-detail-body .go-section-main .go-img-area img {
            width: 100%;
          }

          .go-detail-summary .go-detail-body .go-section-sub {
            padding: 2rem 0;
          }

          .go-detail-summary .go-detail-body .go-section-sub .go-scetion-header {
            margin-bottom: 1rem;
          }

          .go-detail-summary .go-detail-body .go-section-sub .go-scetion-header .go-scetion-title {
            z-index: 2;
            position: relative;
            display: inline-block;
            color: #fd7e14;
            font-size: 1rem;
            font-weight: 600;
            padding: 0.125rem 0.5rem;
          }

          .go-detail-summary .go-detail-body .go-section-sub .go-scetion-header .go-scetion-title:after {
            content: "";
            z-index: 1;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            display: inline-block;
            width: 100%;
            height: 14px;
            background-color: #fd7e14;
            opacity: 0.1;
          }

          .go-summary-sub {
            padding: 0.75rem 0 0.75rem 1.25rem;
            margin-left: 1.25rem;
            border-left: 4px solid #eeeeee;
          }

          .go-summary-sub .go-summary-title {
            font-size: 1.25rem;
          }

          .go-detail .go-detail-body p {
            color: #666666;
            font-size: 1rem;
            line-height: 1.5;
            letter-spacing: -0.2px;
          }

          .go-summary-sub .go-summary-desc {
            font-size: 0.938rem;
            margin-top: 0.5rem;
          }

          h1, h2, h3, h4, h5, h6, p {
            margin-bottom: 0;
          }

          .go-card-reference-inline {
            display: none;
          }

          .go-summary-sub > .go-summary-item + .go-summary-item {
            margin-top: 3rem;
          }

                      </style>
                    </head>
                    <body>
                      ${element.innerHTML}
                    </body>
                  </html>
                `);

    // addStyles(win);
    setTimeout(() => {
      win.focus();
      win.print();
      if (autoClose) {
        setTimeout(function () {
          win.close();
        }, 1);
      }
      cb();
    }, 500);

    return true;
  },
};
